import { createDeferredEditorHook } from '../shared/deferred-editor'

// Public types ----------------------------------------------------------------

export type JsonViewerHost = {
  readonly el: HTMLElement
  readonly handleEvent: (
    name: string,
    callback: (payload: unknown) => void
  ) => unknown
}

// Constants -------------------------------------------------------------------

const EVENTS = ['json-viewer:set-value'] as const

// Public hook -----------------------------------------------------------------

export const FacadeJsonViewer = createDeferredEditorHook<JsonViewerHost>(
  EVENTS,
  async (host) => {
    const { mountEditor } = await import('./engine')

    return () => mountEditor(host)
  }
)
